module.exports = __webpack_public_path__ + "img/m12.22a5bc16.png";